/* eslint-disable no-inner-declarations */
import OpenMenuItem from '../__page/open-menu-item';

class NavigateMenuItems {
	constructor(menuBar, menuListItem, menuGrid, article) {
		this.menuBar = menuBar;
		this.menuListItem = menuListItem;
		this.menuGrid = menuGrid;
		this.article = article;
	}

	navigateToItems(link, firstClick) {
		const dataString = `${'[data-link=' + "'"}${link}']`;
		let linkItems = document.querySelectorAll('[data-link]');
		if (linkItems) {
			linkItems = Array.prototype.slice.call(linkItems);

			linkItems.forEach((item) => {
				if (item.classList.contains('is-active')) {
					item.classList.remove('is-active');
				}
			});
			let currentlinkItems = document.querySelectorAll(dataString);
			currentlinkItems = Array.prototype.slice.call(currentlinkItems);
			currentlinkItems.forEach((item) => {
				item.classList.add('is-active');
			});
		}

		const grid = document.querySelector(this.menuGrid);
		let articles = grid.querySelectorAll(this.article);
		if (articles) {
			articles = Array.prototype.slice.call(articles);
			articles.forEach((article) => {
				const articleData = article.getAttribute('data-type');
				const grid = document.querySelector(this.menuGrid);

				if (!article.classList.contains('is-hidden')) {
					article.classList.add('is-hidden');
				}

				if (link === articleData || link === 'all') {
					const startTime = new Date().getTime() / 1000;

					// equalize the height of .bar-bottom in tiles
					const bottomRowWrap = article.querySelector('.bottom-row-wrap');
					const bottomRowHeight = bottomRowWrap.offsetHeight;
					let barsBottom = article.querySelectorAll('.bar-bottom');

					if (barsBottom) {
						barsBottom = Array.prototype.slice.call(barsBottom);
						barsBottom.forEach((barBottom) => {
							barBottom.style.minHeight = `${bottomRowHeight}px`;
						});
					}

					requestAnimationFrame(addClassWithDelay);
					function addClassWithDelay() {
						const now = new Date().getTime() / 1000;
						const delay = now - startTime;
						if (delay < 0.2) {
							requestAnimationFrame(addClassWithDelay);
						} else {
							article.classList.remove('is-hidden');
							if (link === articleData) {
								if (!grid.classList.contains('is-navigated')) {
									grid.classList.add('is-navigated');
								}
							} else if (link === 'all') {
								if (grid.classList.contains('is-navigated')) {
									grid.classList.remove('is-navigated');
								}
							}
						}
					}
				}
			});
		}
	}
	init() {
		let menuLinks = document.querySelectorAll(this.menuListItem);
		let firstClick = false;
		if (menuLinks) {
			menuLinks = Array.prototype.slice.call(menuLinks);
			menuLinks.forEach((element) => {
				element.addEventListener('click', (e) => {
					const link = e.currentTarget.getAttribute('data-link');
					OpenMenuItem.closeItem();

					if (firstClick) {
						this.navigateToItems(link);
					} else {
						firstClick = true;
						this.navigateToItems(link, firstClick);
					}
				});
			});
		}
		const url = window.location.href;
		const query = url.split('?type=')[1];
		if (query) {
			firstClick = true;
			this.navigateToItems(query, firstClick);
		}
	}
}

export default new NavigateMenuItems('.menu-bar', '.menu-list-item button[data-link]', '.menu-grid', 'article');
